/*
 * @Description:
 * @Date: 2025-06-23 11:13:28
 */
import InvoiceUninvoicedList from '../components/invoice-uninvoiced-list.vue';
import InvoiceRecordList from '../components/invoice-record-list.vue';
import InvoiceFilingList from '../components/invoice-filing-list.vue';
import InvoiceIndividuaFilinglList from '../components/invoice-individua-filingl-list.vue';
export const TABS = {
  1: { label: '未开票订单', value: 1, cmpt: InvoiceUninvoicedList },
  2: { label: '开票记录', value: 2, cmpt: InvoiceRecordList },
  4: { label: '个体发票上传', value: 4, cmpt: InvoiceIndividuaFilinglList },
  3: { label: '开票备案', value: 3, cmpt: InvoiceFilingList }
};

export const INVOICE_TYPE = {
  1: { label: '增值税普通发票', value: 1 },
  2: { label: '增值税专用发票', value: 2 }
};
export const INVOICE_METHODS = {
  0: { label: '纸质发票', value: 0 },
  1: { label: '电子发票', value: 1 }
};
// C端发票状态
export const C_INVOICE_STATUS = {
  0: { label: '未开票', value: 0 },
  1: { label: '待审核', value: 1 },
  2: { label: '已开票', value: 2 },
  3: { label: '已驳回', value: 3 }
};
// 平台发票状态
export const INVOICE_STATUS = {
  0: { label: '待开票', value: 0 },
  1: { label: '待审核', value: 1 },
  2: { label: '已开票', value: 2 },
  3: { label: '购方已驳回', value: 3 },
  4: { label: '待红冲发票', value: 4 },
  5: { label: '红冲待审核', value: 5 },
  6: { label: '已红冲', value: 6 },
  7: { label: '购方已驳回红冲', value: 7 }
};
export const MAIL_TYPE = {
  0: { label: '非邮寄', value: 0 },
  1: { label: '邮寄', value: 1 }
};
export const INVOICE_FUNCTION = {
  1: { label: '蓝票', value: 1 },
  2: { label: '红票', value: 2 }
};
export const INVOICE_AUDIT_TYPE = {
  0: { label: '发票驳回', value: 0 },
  1: { label: '发票通过', value: 1 }
};
// 工业发票状态，改状态可能有问题，应该和C_INVOICE_STATUS一致
export const OFFLINE_INVOICE_STATUS = {
  0: { label: '未提交', value: 0 },
  1: { label: '待开票', value: 1 },
  2: { label: '待确认', value: 2 },
  3: { label: '已驳回', value: 3 },
  4: { label: '已开票', value: 4 }
};
// 个体开票状态
export const INVOICE_GT_STATUS = {
  1: { label: '未上传', value: 1 },
  2: { label: '已上传', value: 2 }
};
